// extracted by mini-css-extract-plugin
module.exports = {"btnWhatsapp":"BtnWhatsapp_btnWhatsapp__3vnGb","logo":"BtnWhatsapp_logo__3umP6"};